import { DataTypes } from "../../../data/DataManager";
import { FieldSchema, FieldValues } from "../../../Schema";
import { LinkedInstance } from "../../common/external-sources/LinkedInstances";
import { User } from "../../common/external-sources/Users";
import { EntryTypes } from "../../common/fields/entryType";
import { Modes } from "../../common/fields/mode";

export const masterDataPicker: FieldSchema = {
  name: "masterDataPicker",
  graphql: { selection: undefined },
  dataTransform: {
    fromGraphql: {
      getter: ({ equipmentCategory, manufacturer, equipmentModel, variant }: FieldValues) => {
        if (equipmentCategory && manufacturer && equipmentModel) {
          return { equipmentCategory, manufacturer, equipmentModel, variant };
        }
        return null;
      },
      fields: ["equipmentCategory", "manufacturer", "equipmentModel", "variant"],
    },
    // Never persisted, by either route: this exists to drive the form and the schema's
    // own cross-field logic, not to be stored.
    toGraphql: undefined,
    toDb: undefined,
  },
  data: { type: DataTypes.OBJECT },
  validation: { required: true },
  form: {
  disabled: {
      getter: ({ entryType, linkedInstance, mode, currentUser }) => {
        return (
          [EntryTypes.STANDALONE_EQUIPMENT, EntryTypes.CLUSTER_SUBEQUIPMENT].includes(entryType as EntryTypes) &&
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["entryType", "linkedInstance", "mode", "currentUser"],
    },
  }
};
